import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Section = ({ children, className }) => (
  <section className={twMerge('flex flex-col gap-6 lg:gap-8', className)}>
    {children}
  </section>
);

Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Section;
